import { ProductGender, ProductSummaryDto } from './product-summary.dto';

export class ProductSummary {
    readonly ean: string;
    readonly sku: string;
    readonly name: string;
    readonly grupa: string;
    readonly typ: string;
    readonly gender: ProductGender | null;

    constructor(dto: ProductSummaryDto) {
        this.ean = dto.ean;
        this.sku = dto.sku;
        this.name = dto.name;
        this.grupa = dto.grupa;
        this.typ = dto.typ;
        this.gender = dto.gender;
    }
}
